module.exports = __webpack_public_path__ + "img/cancel-panel-red.818566ce.svg";